import { State } from 'modules';

export const availableTracks = (state: State) =>
  state.truckEmulator.availableTracks;
export const loadAvailableTracksPending = (state: State) =>
  state.truckEmulator.loadAvailableTracksPending;

export const cancelTruckTrackingPending = (state: State) =>
  state.truckEmulator.cancelTruckTrackingPending;
